import {
  GET_ALL_HOMEWORK_PERFORMANCE,
  GET_STUDENT_HOMEWORK_PERFORMANCE,
  GET_HOMEWORK_PERFORMANCE,
  GET_HOMEWORK_PERFORMANCE_BATCH,
} from "../constants/Type";

const initialState = {
  homeworkPerformance: null,
  students: null,
  extra: null,
  loading: true,
  results: null,
  all: null,
};

const homeworkPerformanceReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_HOMEWORK_PERFORMANCE:
      return {
        ...state,
        homeworkPerformance: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_ALL_HOMEWORK_PERFORMANCE:
      return {
        ...state,
        all: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_HOMEWORK_PERFORMANCE_BATCH:
      return {
        ...state,
        results: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_STUDENT_HOMEWORK_PERFORMANCE:
      return {
        ...state,
        students: { ...payload.data },
        extra: { ...payload.extra },
        loading: false,
      };

    default:
      return state;
  }
};

export default homeworkPerformanceReducer;
